export const genders = ['MISTER', 'MADAME', 'NON-BINARY'];
export const representative = ['PRESIDENT', 'TREASURER'];
